import type { TransactionRequest, TransactionResponse, WalletAccount } from "./types";

// Minimal EIP-1193 provider interface (enough for eth_sendTransaction)
export interface EIP1193Provider {
  request: (args: { method: string; params: unknown[] }) => Promise<unknown>;
}

/**
 * Sends an EVM transaction through an EIP-1193 provider.
 *
 * Important: do NOT include `chainId` in `eth_sendTransaction` params. Wallet signs on the currently connected network.
 * Network validation is handled by TransactionNetworkGuard before transactions are sent.
 */
export async function sendEvmTransaction(
  provider: EIP1193Provider,
  account: WalletAccount,
  tx: TransactionRequest,
): Promise<TransactionResponse> {
  const formattedValue = tx.value ? `0x${BigInt(tx.value).toString(16)}` : undefined;

  const hash = await provider.request({
    method: "eth_sendTransaction",
    params: [
      {
        from: account.address,
        to: tx.to,
        value: formattedValue,
        data: tx.data,
        // Intentionally omit chainId - wallet signs on the currently connected network
      },
    ],
  });

  return {
    hash: hash as string,
    // Reflect the actual connected network (raw id)
    chainId: account.chainId,
  };
}
